export default __webpack_public_path__ + "static/product_006-3495ddc147c2aeb4c25cd03f3c1792f2.jpg";